/**
 * @generated SignedSource<<78c5602e3dea0319e1afd70b5a13eb82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RpEulaUpdateUserTermsOfAgreementMutation$variables = {
  termsOfAgreement: boolean;
};
export type RpEulaUpdateUserTermsOfAgreementMutation$data = {
  readonly updateUserTermsOfAgreement: {
    readonly ok: boolean | null;
  } | null;
};
export type RpEulaUpdateUserTermsOfAgreementMutation = {
  response: RpEulaUpdateUserTermsOfAgreementMutation$data;
  variables: RpEulaUpdateUserTermsOfAgreementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "termsOfAgreement"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "termsOfAgreement",
        "variableName": "termsOfAgreement"
      }
    ],
    "concreteType": "UpdateUserTermsOfAgreement",
    "kind": "LinkedField",
    "name": "updateUserTermsOfAgreement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RpEulaUpdateUserTermsOfAgreementMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RpEulaUpdateUserTermsOfAgreementMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f546b3de4c74e3d58c1b62913247f433",
    "id": null,
    "metadata": {},
    "name": "RpEulaUpdateUserTermsOfAgreementMutation",
    "operationKind": "mutation",
    "text": "mutation RpEulaUpdateUserTermsOfAgreementMutation(\n  $termsOfAgreement: Boolean!\n) {\n  updateUserTermsOfAgreement(termsOfAgreement: $termsOfAgreement) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "b043d4ab82f71a676f3e70bc9c2fe36a";

export default node;
